// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3jIrq","productName":"Table_productName__PuZpT"};